import React, { forwardRef, useCallback, useMemo } from 'react';

// DEPENDENCIES
import cloneDeep from 'lodash/cloneDeep';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

// MAIN COMPONENT
export const specialOptions = Component => {
  return forwardRef(({
    options,
    defaultValue,
    useNone,
    useAll,
    useOther,
    ...props
  }, ref) => {

    // CALLBACKS
    const specialOption = useCallback(
      (optionDefault, optionProp) => {
        const option = {
          ...optionDefault,
          ...(isObject( optionProp) ?  optionProp : isString( optionProp) ? {label:  optionProp} : {})
        };
        return option
      },
      []
    )

    // MEMOS
    const specialOptionsMemo = useMemo(
      () => {
        const obj = {};
        if (useNone) obj.none = specialOption({
          label: 'None',
          value: ''
        }, isString(useNone) ? {
          label: useNone
        } : useNone);
        if (useAll) obj.all = specialOption({
          label: 'All',
          value: options.map(({ value }) => value).filter(v => v !== undefined && v !== '').join(',')
        }, isString(useAll) ? {
          label: useAll
        } : useAll);
        if (useOther) obj.other = specialOption({
          label: 'Other',
          value: 'other'
        }, isString(useOther) ? {
          label: useOther
        } : useOther);
        return obj;
      },
      [options, useNone, useAll, useOther, specialOption]
    )
    const optionsMemo = useMemo(
      () => {
        const arr = cloneDeep(options);
        if (specialOptionsMemo.none) arr.unshift(specialOptionsMemo.none);
        if (specialOptionsMemo.all) arr.unshift(specialOptionsMemo.all);
        if (specialOptionsMemo.other) arr.push(specialOptionsMemo.other);
        return arr;
      },
      [options, specialOptionsMemo]
    )
    const defaultValueMemo = useMemo(
      () => {
        if (defaultValue) return;
        if (specialOptionsMemo.none?.default) return specialOptionsMemo.none.value;
        if (specialOptionsMemo.all?.default) return specialOptionsMemo.all.value;
        if (specialOptionsMemo.other?.default) return specialOptionsMemo.other.value;
      },
      [defaultValue, specialOptionsMemo]
    )

    // RENDER
    return <Component
      {...props}
      options={optionsMemo}
      defaultValue={defaultValueMemo}
      ref={ref}
    />
  })
}
